import { UfvPolicy } from "./UfvPolicy";

export const ufvPolicy = new UfvPolicy()